import { regex, required } from 'react-admin';

export const REQUIRED_MESSAGE = 'The field is required';
export const SELECT_REQUIRED_MESSAGE = 'Please choose one of the values';
export const validateEmail = [
  required(REQUIRED_MESSAGE),
  regex(/^[a-z0-9._]+@galacticentertainment.com$/, 'Must be a valid email'),
];
